module.exports = __webpack_public_path__ + "media/images/shop-dc21ff7da7f066263956ae7720e1f480.svg";